'use strict';

/**
 * Returns the video component wrapper related to the clicked target.
 *
 * @param {jQuery} $target - The jQuery element that triggered the event.
 * @returns {jQuery} The closest video component wrapper.
 */
function getVideoWrapper($target) {
    return $target.closest('.experience-component.experience-ckc_assets-customvideocomponent')
        .find('.video-component')
        .first();
}

/**
 * Toggles play and pause icons based on the video's current state.
 *
 * @param {jQuery} $wrapper - The video component wrapper.
 * @param {jQuery} $video - The video element.
 */
function togglePlayIcon($wrapper, $video) {
    var $playButton = $wrapper.find('.play-btn');
    var isPaused = $video.get(0).paused;
    $playButton.find('.pauseIcon').toggleClass('d-none', isPaused);
    $playButton.find('.playIcon').toggleClass('d-none', !isPaused);
}

/**
 * Toggles mute and unmute icons based on the video's audio state.
 *
 * @param {jQuery} $wrapper - The video component wrapper.
 * @param {jQuery} $video - The video element.
 */
function toggleVolumeIcon($wrapper, $video) {
    var $volumeButton = $wrapper.find('.volume-button');
    var isMuted = $video.get(0).muted;
    $volumeButton.find('.muteIcon').toggleClass('d-none', !isMuted);
    $volumeButton.find('.unmuteIcon').toggleClass('d-none', isMuted);
}

/**
 * Initializes the video state by muting it by default and
 * syncing play and volume icons with the current video state.
 *
 * @param {jQuery} $wrapper - The video component wrapper.
 */
function initVideoState($wrapper) {
    var $video = $wrapper.find('video').first();
    if (!$video.length) {
        return;
    }
    $video.prop('muted', true);
    togglePlayIcon($wrapper, $video);
    toggleVolumeIcon($wrapper, $video);
    $video.on('play pause ended', function () {
        togglePlayIcon($wrapper, $video);
    });
}

/**
 * Handles play button click events.
 * Plays, pauses, or restarts the video depending on its state.
 *
 * @param {Event} e - The click event object.
 */
function handlePlayClick(e) {
    e.preventDefault();
    var $wrapper = getVideoWrapper($(this));
    var $video = $wrapper.find('video').first();
    if (!$video.length) {
        return;
    }
    if ($video.get(0).ended) {
        $video.get(0).currentTime = 0;
    }
    if ($video.get(0).paused) {
        $video.get(0).play();
    } else {
        $video.get(0).pause();
    }
    togglePlayIcon($wrapper, $video);
}

/**
 * Handles volume button click events.
 * Toggles mute and unmute states for the video.
 *
 * @param {Event} e - The click event object.
 */
function handleVolumeClick(e) {
    e.preventDefault();
    var $wrapper = getVideoWrapper($(this));
    var $video = $wrapper.find('video').first();
    if (!$video.length) {
        return;
    }
    $video.prop('muted', !$video.get(0).muted);
    toggleVolumeIcon($wrapper, $video);
}

/**
 * Binds play and volume button events for all custom video components
 * and initializes their default state.
 */
function bindVideoEvents() {
    $('.experience-component.experience-ckc_assets-customvideocomponent .video-component').each(function () {
        var $wrapper = $(this);
        var $playButton = $wrapper.find('.play-btn');
        var $volumeButton = $wrapper.find('.volume-button');

        initVideoState($wrapper);

        $playButton.off('click').on('click', handlePlayClick);
        $volumeButton.off('click').on('click', handleVolumeClick);
    });
}

module.exports = function () {
    bindVideoEvents();
};
